import { Skeleton } from '@/components/ui/Skeleton';
import type { Taxonomy } from '@/types/anime';

interface GenreChipsProps {
	genres: Taxonomy[];
	/** '' nghĩa là "Tất cả". */
	activeSlug: string;
	onSelect: (slug: string) => void;
	isLoading?: boolean;
	includeAllOption?: boolean;
	className?: string;
}

/**
 * Chips thể loại. Bản gốc hardcode 8 chuỗi tiếng Việt rồi so khớp bằng
 * `includes()` trên chuỗi meta — gần như luôn ra rỗng. Ở đây dùng slug thật từ
 * GET /the-loai và đẩy thẳng vào query param `category` của API.
 */
export function GenreChips({
	genres,
	activeSlug,
	onSelect,
	isLoading = false,
	includeAllOption = true,
	className = '',
}: GenreChipsProps) {
	if (isLoading) {
		return (
			<div className={`flex flex-wrap gap-2.5 ${className}`}>
				{Array.from({ length: 10 }, (_, index) => (
					<Skeleton key={index} className="h-9 w-24 rounded-full" />
				))}
			</div>
		);
	}

	const options = includeAllOption
		? [{ name: 'Tất cả', slug: '' }, ...genres]
		: genres;

	return (
		<div className={`flex flex-wrap gap-2.5 ${className}`}>
			{options.map((genre) => {
				const selected = genre.slug === activeSlug;
				return (
					<button
						key={genre.slug || 'all'}
						type="button"
						onClick={() => onSelect(genre.slug)}
						aria-pressed={selected}
						className={`rounded-full border px-3.5 py-2 text-sm transition duration-200 ${
							selected
								? 'border-accent bg-accent/15 text-ink'
								: 'border-line bg-white/[0.02] text-muted hover:border-accent hover:text-ink'
						}`}
					>
						{genre.name}
					</button>
				);
			})}
		</div>
	);
}
